module.exports = "<div class=\"c-form__field c-form__field--select\" ng-if=$ctrl.displaySelect()> <select name=type class=\"select-type / c-form__select / c-select c-select--type\" ng-attr-data-grid-filter=\"{{ $ctrl.filter }}\" ng-model=$ctrl.eventType> <option value=* disabled=disabled>Select a type...</option> <option value=day ng-if=$ctrl.displaySpaDays>Spa Days</option> <option value=treatment>Treatments</option> </select> <label class=\"c-form__label t-text--secondary\" for=type>I'm looking for...</label> </div> ";


//////////////////
// WEBPACK FOOTER
// ./frontend/storefront/app/modules/page/views/selectType.html
// module id = 761
// module chunks = 0